import { render, staticRenderFns } from "./RolesView.vue?vue&type=template&id=32dc3f93&scoped=true"
import script from "./RolesView.vue?vue&type=script&lang=js"
export * from "./RolesView.vue?vue&type=script&lang=js"
import style0 from "./RolesView.vue?vue&type=style&index=0&id=32dc3f93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dc3f93",
  null
  
)

export default component.exports